import React, { memo, useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import Button from './Button';
import { rem } from './values';
import AmountPill from './AmountPill';
const AmountSelectors = ({ moneyInputRef, amounts, maxAmount, }) => {
    const setMoneyInputAmount = useCallback((amount) => () => {
        moneyInputRef.current?.setAmount(amount);
    }, [moneyInputRef]);
    return (<View style={styles.amountSelectors}>
      {amounts.map((amount) => (<View key={String(amount)} style={styles.selector}>
          <AmountPill selected value={amount} currency="GBP" onPress={setMoneyInputAmount(amount)}/>
        </View>))}
      {!!maxAmount?.value && (<View style={styles.selector}>
          <Button small square title="MAX" brandLight containerStyle={styles.maxBtn} onPress={setMoneyInputAmount(maxAmount.value)}/>
        </View>)}
    </View>);
};
export default memo(AmountSelectors);
const styles = StyleSheet.create({
    amountSelectors: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    selector: {
        paddingHorizontal: rem(4),
    },
    maxBtn: {
        paddingHorizontal: rem(24),
    },
});
